const track = {
  deliveryNo: '送货单号',
  orderNo: '订单号',
  orderType: '订单类型',
  orderStatus: '订单状态',
  factoryCode: '发货工厂编码',
  carrierCode: '承运商编码',
  carrierName: '承运商',
  voucherDate: '凭证日期',
  route: '路线',
  shiptoNo: '送达方编码',
  shiptoName: '送达方',
  shipAddress: '送货地址',
  totalShipQty: '总发货数量',
  totalShipVolume: '总发货体积',
  pickupDate: '提货日期',
  expectPickupDate: '预计到货日期',
  transitTime: '在途时间',
  signDate: '客户签收日期',
  deliveryLate: '交货是否迟到',
  deliveryLateReason: '交货迟到原因',
  deliveryLateReasonCategory: '交货迟到原因归类',
  receiptReturnTime: '回单返回时间',
  receiptReturnDate: '回单返回日期',
  receiptLate: '回单是否迟到',
  receiptLateReason: '回单迟到原因',
  receiptLateReasonCategory: '回单迟到原因归类',
  pickupPlateNo: '提货车牌号',
  vehicleType: '类型(油/电/气)',
  pickupVehicleModel: '提货车型(米)',
  maxLoadVolume: '最大装载量(立方)',
  voucherDateStart: '凭证日期开始',
  voucherDateEnd: '凭证日期结束',
  pickupDateStart: '提货日期开始',
  pickupDateEnd: '提货日期结束',
  signDateStart: '签收日期开始',
  signDateEnd: '签收日期结束',
  orderTypePop: 'pop订单',
  orderTypeStandard: '标准订单',
  statusNew: '新建',
  statusShipped: '发货',
  statusArrived: '到货',
  statusWaitReject: '待确认拒收',
  statusRejectDone: '拒收完成',
  delayTypeSigning: '签收',
  delayTypeReceipt: '回单',
  vehicleInfo: '车辆信息',
  dtInfo: '明细信息',
  materielSeq: '商品行号',
  materielNo: '商品编号',
  productNo: '产品编码',
  productName: '产品名称',
  shipQty: '订货数量',
  shipVolume: '订货体积',
  shipWeight: '订货重量',
  salesUnit: '销售单位',
  actShipQty: '实际发货数量',
  actShipVolume: '实际发货体积',
  actShipWeight: '实际发货重量',
  msg: {}
};
export default track;



// WEBPACK FOOTER //
// ./src/page/track/lang/track.zh.js